{
  "instances": {
    "scheduledtasks": {
      "label": "Geplante Tasks",
      "no_scheduledtasks": "Keine geplanten Aufgaben.",
      "cron": {
        "expression": "Expression",
        "runnable": "Runnable",
        "title": "Cron"
      },

      "fixed_delay": {
        "initial_delay_ms": "Verzögerung (ms)",
        "interval_ms": "Intervall (ms)",
        "runnable": "Runnable",
        "title": "Feste Verzögerung"
      },
      "fixed_rate": {
        "initial_delay_ms": "Verzögerung (ms)",
        "interval_ms": "Intervall (ms)",
        "runnable": "Runnable",
        "title": "Fixed Rate"
      }
    }
  }
}
